import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container, Col, Row, Table, Button, Input, InputGroup, InputGroupAddon, Form } from 'reactstrap';
import Pagination from 'react-js-pagination';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../i18next';
import { NavLink } from 'react-router-dom';
import { Link } from 'react-router-dom';

import {
    DEFAULT_PAGE_SIZE,
    DEFAULT_PAGING_RANGE,
    INSTORE_ID,
    CURBSIDE_ID
} from '../../../utils/Constants';
import {
    getPriceWithCurrencySymbol,
    localizeCountryNames,
    localizeStatuses,
    renderOrderTypeSrc,
    renderPaymentTypeIcon,
    transformProductPrice,
    negativeIntegersValidation
} from '../../../utils/CommonUtils';
import { loadOrdersHistory, clearOrdersHistory, getOrdersDetails, getRefundHistory, loadRestaurant, downloadOrderHistory, getRestaurantGiftCardProviderSettings, getRestaurantGiftCardProviderTypeId } from '../../../actions/index';
import RestaurantUtils from '../../../utils/RestaurantUtils';
import OrderDetailsScreen from "./OrderDetailsScreen";
import SearchButton from '../../common/SearchButton';
import OrderSourceSelector from "../../common/OrderSourceSelector";

class OrdersHistory extends Component {
    constructor(props) {
        super(props);

        this.state = {
            advancedSearch: false,
            currency: '',
            searchQuery: {
                orderId: '',
                customerName: '',
                customerEmail: '',
                customerPhone: '',
                placedTime: '',
                wantedTime: ''
            },
            currentPageNumber: 1,
            orderDetailsScreenOpened: false
        }

        this.changeState = this.changeState.bind(this);
        this.search = this.search.bind(this);
        this.clearSearch = this.clearSearch.bind(this);
        this.toggleSearch = this.toggleSearch.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.toggleOrderDetailsScreen = this.toggleOrderDetailsScreen.bind(this);
    }

    componentDidMount() {
        const restaurantId = this.props.match.params.id;
        this.props.loadOrdersHistory(restaurantId, 1, this.state.searchQuery);

        this.openOrderDetailsFromNotifications();

        // this.props.getRestaurantGiftCardProviderSettings(restaurantId);
        this.props.getRestaurantGiftCardProviderTypeId(restaurantId);
    }

    componentDidUpdate(prevProps) {
        if (this.props.match.params.id !== prevProps.match.params.id) {
            const restaurantId = this.props.match.params.id;
            this.props.loadOrdersHistory(restaurantId, 1, this.state.searchQuery);
        }

        this.openOrderDetailsFromNotifications();
    }

    componentWillUnmount() {
        this.props.clearOrdersHistory();
    }

    copyStateFromProps() {
        if (this.props.restaurant.currency !== undefined && this.props.restaurant.currency !== null &&
            this.props.restaurant.currency !== '' && !this.state.stateAlreadyCopiedFromProps) {

            this.setState({
                currency: this.props.restaurant.currency,
                stateAlreadyCopiedFromProps: true
            });
        }
    }

    rejectedOrderReseted() {
        const restaurantId = this.props.match.params.id;
        this.props.loadOrdersHistory(restaurantId, 1, this.state.searchQuery);
    }

    openOrderDetailsFromNotifications() {
        if (new URLSearchParams(window.location.search).get('orderDetailsOpen')) {

            const locatonHrefArray = window.location.href.split('?');
            const removeSearchString = window.history.replaceState({}, document.title, `${locatonHrefArray[0]}`);
            this.toggleOrderDetailsScreen(removeSearchString);

            // if (_.isEmpty(this.props.orderDetails.restaurantDetails)) {
            //     const restaurantId = this.props.restaurant.id;
            //     // this.props.loadRestaurant(restaurantId);
            // }
        }
    }

    loadOrderDetailsScreen(orderId) {
        const restaurantId = this.props.restaurant.id;
        this.props.loadRestaurant(restaurantId);

        this.props.getOrdersDetails(orderId, () => {
            this.toggleOrderDetailsScreen();
        });

        this.props.getRefundHistory(orderId);
    }

    toggleOrderDetailsScreen(callbackFunction) {
        this.setState({
            orderDetailsScreenOpened: !this.state.orderDetailsScreenOpened
        }, () => {
            if (callbackFunction) {
                callbackFunction()
            }
        });
    }

    toggleSearch() {
        // toggling the search should reset the search query
        const restaurantId = this.props.match.params.id;

        this.setState({
            advancedSearch: !this.state.advancedSearch,
            searchQuery: {
                orderId: '',
                customerName: '',
                customerEmail: '',
                customerPhone: '',
                placedTime: '',
                wantedTime: ''
            },
            currentPageNumber: 1
        });

        this.props.loadOrdersHistory(restaurantId, 1, this.state.searchQuery);
    }

    changeState({ target }) {

        this.setState({
            searchQuery: {
                ...this.state.searchQuery,
                [target.name]: target.value,
            }
        });
    }

    search() {
        //new search should always start from page 1
        const restaurantId = this.props.match.params.id;

        this.props.loadOrdersHistory(restaurantId, 1, this.state.searchQuery);

        this.setState({
            currentPageNumber: 1
        });
    }

    clearSearch() {
        //new search should always start from page 1
        const restaurantId = this.props.match.params.id;
        const advancedSearch = this.state.advancedSearch;
        
        if (advancedSearch) {
            this.setState({
                searchQuery: {
                    orderId: '',
                    customerName: '',
                    customerEmail: '',
                    customerPhone: '',
                    placedTime: '',
                    wantedTime: ''
                },
                currentPageNumber: 1
            }, () => {
                this.props.loadOrdersHistory(restaurantId, 1, this.state.searchQuery);
            });
        } else if (!advancedSearch) {
            this.setState({
                searchQuery: {
                    orderId: '',
                    customerName: '',
                    customerEmail: '',
                    customerPhone: '',
                    placedTime: '',
                    wantedTime: ''
                },
                currentPageNumber: 1
            }, () => {
                document.getElementById("placedTime").value = '';
                document.getElementById("wantedTime").value = '';
                this.props.loadOrdersHistory(restaurantId, 1, this.state.searchQuery);
            });
        }
    }

    keyPress(event) {
        if (event.keyCode === 13) { // this is Enter
            this.search();
        }
    }

    handlePageChange(pageNumber) {
        const restaurantId = this.props.restaurant.id;

        this.setState({
            currentPageNumber: pageNumber
        });

        this.props.loadOrdersHistory(restaurantId, pageNumber, this.state.searchQuery);
    }

    renderSimpleSearch() {
        const { flexEnd, inputGroupSearch, inputSearch, rowMarginBottom, simpleSearchPipe, inputGroupAddon, cursorPointer, zeroPadding } = styles;
        const { orderId } = this.state.searchQuery;

        return (
            <Col>
                <Row>
                    <Col xs={3} style={zeroPadding}>
                        <InputGroup style={inputGroupSearch}>
                            <Input
                                type="text" name="orderId" id="orderId" placeholder={i18n.t('screens:orderHistoryScreen.orderId')} value={orderId}
                                onChange={this.changeState}
                                onKeyDown={this.keyPress.bind(this)} style={inputSearch} />
                            <InputGroupAddon addonType="append" style={inputGroupAddon}>
                                <div onClick={this.search} style={cursorPointer} ><MaterialIcon icon="search" color="#0288D1" size={28} /></div>
                            </InputGroupAddon>
                        </InputGroup>
                    </Col>
                </Row>
                <Row style={rowMarginBottom}>
                    <Col xs={3}>
                        <Row>
                            <Col style={flexEnd}>
                                <Button color="link" onClick={this.clearSearch}>{i18n.t('common:searchForms.clear')}</Button>
                                <span style={simpleSearchPipe}>|</span>
                                <Button color="link" onClick={this.toggleSearch}>{i18n.t('common:searchForms.advancedSearch')}</Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>
        );
    }

    onKeyUp(event) {
        event.preventDefault();
        if (event.keyCode === 13) {
            document.getElementById('advanceSearchButton').click();
        }
    }

    renderAdvancedSearch() {
        const { flexEnd, paddingLeftRight,
            rowMarginBottom, advancedSearchPipe, orderIdCol } = styles;
        const { orderId, customerName, customerEmail, customerPhone } = this.state.searchQuery;

        return (
            <Col xs="auto" sm={8} >
                <Form id='advanceSearchForm' onKeyUp={this.onKeyUp}>
                    <Row>
                        <Col style={orderIdCol}>
                            <Input type="number" name="orderId" id="orderId" placeholder={i18n.t('screens:orderHistoryScreen.orderId')} value={orderId} onChange={this.changeState} className={"inputOrderId"} onKeyPress={(e) => negativeIntegersValidation(e)} />
                        </Col>
                        <Col style={paddingLeftRight}>
                            <Input type="text" name="customerName" id="customerName" placeholder={i18n.t('screens:orderHistoryScreen.customerName')} value={customerName} onChange={this.changeState} />
                        </Col>
                        <Col style={paddingLeftRight}>
                            <Input type="text" name="customerPhone" id="customerPhone" placeholder={i18n.t('screens:orderHistoryScreen.customerPhone')} value={customerPhone} onChange={this.changeState} />
                        </Col>
                        <Col style={paddingLeftRight}>
                            <Input type="text" name="customerEmail" id="customerEmail" placeholder={i18n.t('screens:orderHistoryScreen.customerEmail')} value={customerEmail} onChange={this.changeState} />
                        </Col>
                        <Col style={paddingLeftRight}>
                            <Input type="text" onFocus={(e) => e.target.type = 'date'} onBlur={(e) => e.target.type = 'text'} name="placedTime" id="placedTime" placeholder={i18n.t('screens:orderDetailsScreen.placedTime')} onChange={this.changeState} />
                        </Col>
                        <Col style={paddingLeftRight}>
                            <Input type="text" onFocus={(e) => e.target.type = 'date'} onBlur={(e) => e.target.type = 'text'} name="wantedTime" id="wantedTime" placeholder={i18n.t('screens:orderHistoryScreen.wantedTime')} onChange={this.changeState} />
                        </Col>
                        <Col>
                            <SearchButton search={this.search.bind(this)} />
                        </Col>
                    </Row>
                </Form>
                <Row style={rowMarginBottom}>
                    <Button
                        color='primary'
                        onClick={() => this.props.downloadOrderHistory(this.state.currentPageNumber, this.state.searchQuery, this.props.restaurant.id)}
                        style={{ marginTop: 10, display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
                        <MaterialIcon icon="cloud_download" color="#fff" size={19} />
                        <span style={{ marginLeft: 6 }}>{i18n.t('screens:centralOrdersLog.download')}</span>
                    </Button>
                    {/* <Button
                        color='primary'
                        onClick={() => this.props.downloadOrderHistory(this.state.currentPageNumber, this.state.searchQuery, this.props.restaurant.id)}
                        style={{ marginTop: 10 }}
                        disabled={true}>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <MaterialIcon icon="cloud_download" color="#fff" size={19} />
                            <span style={{ marginLeft: 6 }}>{i18n.t('screens:centralOrdersLog.download')}</span>
                        </div>
                        <div style={{ fontSize: 10 }}>(Under maintenance)</div>
                    </Button> */}
                    <Col style={flexEnd}>
                        <Button color="link" onClick={() => this.clearSearch()}>{i18n.t('common:searchForms.clear')}</Button>
                        <span style={advancedSearchPipe}>|</span>
                        <Button color="link" onClick={() => this.toggleSearch()}>{i18n.t('common:searchForms.simpleSearch')}</Button>
                    </Col>
                </Row>
            </Col>
        );
    }

    renderOrderHistoryTable() {
        const { zeroPadding, textAlignCenter } = styles;

        return (
            <Col style={zeroPadding}>
                <Table responsive hover>
                    <thead>
                        <tr>
                            <th>{i18n.t('screens:orderHistoryScreen.orderIdTable')}</th>
                            <th>{i18n.t('screens:orderHistoryScreen.date')}</th>
                            <th>{i18n.t('screens:orderHistoryScreen.wantedTime')}</th>
                            <th>{i18n.t('screens:orderHistoryScreen.orderType')}</th>
                            <th>{i18n.t('screens:orderHistoryScreen.customerName')}</th>
                            <th>{i18n.t('screens:orderHistoryScreen.orderAddress')}</th>
                            <th style={{textAlign: 'center'}}>{i18n.t('screens:orderHistoryScreen.paymentType')}</th>
                            <th>{i18n.t('screens:orderDetailsScreen.totalPrice')}</th>
                            <th>{i18n.t('screens:orderHistoryScreen.status')}</th>
                            <th>{i18n.t('screens:orderHistoryScreen.source')}</th>
                            <th>{i18n.t('screens:orderDetailsScreen.rejectReason')}</th>
                        </tr>
                    </thead>
                    <tbody>{this.renderTableRows()}</tbody>
                </Table>
            </Col>
        );
    }

    renderTableRows() {
        const { selectOrderStyle, textAlignCenter, loyaltyIconStyle } = styles;
        const currency = this.state.currency;

        if (this.props.orders.content !== undefined && this.props.orders.content !== null) {
            return this.props.orders.content.map((order, i) => {

                const orderStatusColor = RestaurantUtils.getOrderStatusColor(order.orderStatus);
                const statusColor = { color: orderStatusColor };

                let orderAddress = (order.orderAddress.fullAddress !== null) ? order.orderAddress.fullAddress : order.orderAddress.street + ', ' + order.orderAddress.city + ', ' + localizeCountryNames(order.orderAddress.country);
                if (order.orderType.id === INSTORE_ID) {
                    orderAddress = order.inStoreSeat;
                }
                let orderAddressValue = order.orderType.id === CURBSIDE_ID ? order.carDetails : orderAddress

                const orderTypeIconSrc = renderOrderTypeSrc(order.orderType.id);

                let paymentTypeIconSrc = renderPaymentTypeIcon(order.tenderType.id);
                const orderServiceFee = order.serviceFee ? order.serviceFee : 0;

                let renderLoyaltyIcon = order.paidWithVoucher;

                let price = parseFloat(order.priceTotal) + orderServiceFee;

                const priceTotalWithCurrency = getPriceWithCurrencySymbol(transformProductPrice(price), currency);

                const isOnlyLoyalty = renderLoyaltyIcon && price === 0 ? true : false;

                if (isOnlyLoyalty) {
                    paymentTypeIconSrc = null;
                }

                const isLoyaltyIconStyle = renderLoyaltyIcon && paymentTypeIconSrc ? loyaltyIconStyle : null;
                const loyaltyIconSrc = renderPaymentTypeIcon(3, isLoyaltyIconStyle, isOnlyLoyalty); // Loyalty fake id
                const isGiftCardDiscount = order.giftCardDiscount ? true : false;

                return (
                    <tr key={i}>
                        <td style={selectOrderStyle} onClick={() => this.loadOrderDetailsScreen(order.orderId)}>{order.orderId}</td>
                        <td>{order.date}</td>
                        <td>{order.wantedTime}</td>
                        <td style={textAlignCenter}>{orderTypeIconSrc}</td>
                        <td>
                            <NavLink tag={Link} style={selectOrderStyle} to={`/restaurant/${this.props.restaurant.id}/customer-insight/${order.customerId}`}>
                                {order.customerName}
                            </NavLink>
                        </td>
                        <td>{orderAddressValue}</td>
                        <td style={textAlignCenter}>
                            <div style={{display: 'flex'}}>
                            {
                                renderLoyaltyIcon && paymentTypeIconSrc ?
                                    <React.Fragment>
                                        <span style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                                            {paymentTypeIconSrc}
                                            {loyaltyIconSrc}
                                        </span>
                                    </React.Fragment> :
                                    renderLoyaltyIcon && !paymentTypeIconSrc ? loyaltyIconSrc : paymentTypeIconSrc
                            }
                            {
                                isGiftCardDiscount ? 
                                <span style={{marginLeft: '11px'}}>
                                    <MaterialIcon icon="card_giftcard" size={28} width={24} height={26} color='#0288d1' />
                                </span> : null
                            }
                            </div>
                        </td>
                        <td>{priceTotalWithCurrency}</td>
                        <td><span style={statusColor}>{(order.orderStatus !== null) ? localizeStatuses(order.orderStatus) : i18n.t('screens:orderHistoryScreen.noStatus')}</span></td>
                        <td><OrderSourceSelector source={order.source} /></td>
                        <td>{order.rejectReason ? i18n.t(`screens:mainContainer.${order.rejectReason}`) : null}</td>
                    </tr>
                );
            });
        }
    }

    renderPagination() {
        const { flexEnd } = styles;

        return (
            <Col style={flexEnd}>
                <Pagination
                    activePage={this.props.orders.number + 1}
                    itemsCountPerPage={DEFAULT_PAGE_SIZE}
                    totalItemsCount={this.props.orders.totalElements}
                    pageRangeDisplayed={DEFAULT_PAGING_RANGE}
                    itemClass='page-item'
                    linkClass='page-link'
                    onChange={this.handlePageChange}
                />
            </Col>
        );
    }

    refreshResults() {
        const restaurantId = this.props.match.params.id;
        this.props.loadOrdersHistory(restaurantId, this.state.currentPageNumber, this.state.searchQuery);
    }

    render() {
        const { containerStyle } = styles;
        const restaurantId = this.props.restaurant.id;

        this.copyStateFromProps();

        return (
            <Container fluid style={containerStyle}>
                <Row>{!this.state.advancedSearch ? this.renderAdvancedSearch() : this.renderSimpleSearch()}</Row>
                <Row>{this.renderOrderHistoryTable()}</Row>
                <Row>{this.renderPagination()}</Row>
                {this.state.orderDetailsScreenOpened ? <OrderDetailsScreen
                    isOpen={this.state.orderDetailsScreenOpened}
                    onToggle={this.toggleOrderDetailsScreen}
                    orderDetails={this.props.orderDetails}
                    currency={this.state.currency}
                    restaurantId={restaurantId}
                    currentPageNumber={this.state.currentPageNumber}
                    rejectedOrderReseted={this.rejectedOrderReseted.bind(this)}
                    refreshResults={this.refreshResults.bind(this)}
                    giftCardProviderType={this.props.giftCardProvider.restaurantGiftCardProviderTypeId ? this.props.giftCardProvider.restaurantGiftCardProviderTypeId.type : null}
                /> : null}
            </Container>
        );
    }
}

const mapStateToProps = state => {
    return {
        orders: state.orders,
        restaurant: state.restaurant,
        orderDetails: state.оrderDetails,
        giftCardProvider: state.giftCardProvider
    }
}

export default connect(mapStateToProps, { loadOrdersHistory, clearOrdersHistory, getOrdersDetails, getRefundHistory, loadRestaurant, downloadOrderHistory, getRestaurantGiftCardProviderSettings, getRestaurantGiftCardProviderTypeId })(OrdersHistory);

let styles = {
    containerStyle: {
        width: '100%',
        marginTop: 20
    },
    flexEnd: {
        display: 'flex',
        justifyContent: 'flex-end',
        paddingRight: 0
    },
    inputGroupSearch: {
        border: '1px solid lightgray'
    },
    inputSearch: {
        border: 0
    },
    paddingLeftRight: {
        paddingLeft: 5,
        paddingRight: 5
    },
    rowMarginBottom: {
        marginBottom: 10
    },
    simpleSearchPipe: {
        height: 46,
        textAlign: 'center',
        verticalAlign: 'middle',
        padding: '10px 0',
        color: '#007bff'
    },
    inputGroupAddon: {
        marginTop: '10px'
    },
    cursorPointer: {
        cursor: 'pointer'
    },
    advancedSearchPipe: {
        height: 46,
        textAlign: 'center',
        verticalAlign: 'middle',
        padding: '10px 0',
        color: '#007bff'
    },
    zeroPadding: {
        paddingLeft: 0,
        paddingRight: 0
    },
    orderIdCol: {
        paddingLeft: 0,
        paddingRight: 5
    },
    selectOrderStyle: {
        color: '#0087d7',
        cursor: 'pointer'
    },
    textAlignCenter: {
        textAlign: 'center'
    },
    verticalAlignBaseline: {
        verticalAlign: 'baseline'
    },
    loyaltyIconStyle: {
        marginLeft: '11px'
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/orders/OrdersHistory.js